// @flow
import { createSelector } from "reselect";
import { PREDEFINED_TREE_NODES } from "../data/consts";
import { selectGoogleDrive } from ".";

const selectTree: Object => Object = createSelector(
	selectGoogleDrive,
	(gdrive) => gdrive.tree,
);

export const selectTreeFolders: Object => Object = createSelector(
	selectTree,
	(tree) => tree.folders,
);

export const selectMyDrive: Object => Object = createSelector(
	selectTreeFolders,
	(folders) => folders[PREDEFINED_TREE_NODES.MY_DRIVE],
);

const selectSharedDrive: Object => Object = createSelector(
	selectTreeFolders,
	(folders) => folders[PREDEFINED_TREE_NODES.SHARED_DRIVE],
);

const selectSharedWithMe: Object => Object = createSelector(
	selectTreeFolders,
	(folders) => folders[PREDEFINED_TREE_NODES.SHARED_WITH_ME],
);

const selectStarred: Object => Object = createSelector(
	selectTreeFolders,
	(folders) => folders[PREDEFINED_TREE_NODES.STARRED],
);

const selectRecent: Object => Object = createSelector(
	selectTreeFolders,
	(folders) => folders[PREDEFINED_TREE_NODES.RECENT],
);

export const selectTreeStatuses: Object => Object = createSelector(
	selectTree,
	(tree) => tree.statuses,
);

export const selectTreeDefaultExpanded: Object => Object = createSelector(
	selectMyDrive,
	({
		id, kind, driveId, path,
	}) => ({
		id, kind, driveId, path,
	}),
);

const flatten = (node: {children: Object[]}, depth: number, acc: Object[], dictionary) => {
	if (node) {
		acc.push({
			...node,
			depth,
		});

		if (node.children && node.children.length > 0) {
			node.children.forEach((childNodeId) => {
				if (dictionary[childNodeId]) {
					flatten(
						dictionary[childNodeId],
						depth + 1,
						acc,
						dictionary,
					);
				}
			});
		}
	}

	return acc;
};

export const selectTreeItems: Object => Object[] = createSelector(
	selectMyDrive,
	selectSharedDrive,
	selectSharedWithMe,
	selectStarred,
	selectRecent,
	selectTreeFolders,
	(
		myDriveFolder,
		sharedDriveFolder,
		sharedWithMe,
		starred,
		recent,
		...args
	) => [
		...flatten(myDriveFolder, 0, [], ...args),
		...flatten(sharedDriveFolder, 0, [], ...args),
		...flatten(sharedWithMe, 0, [], ...args),
		...flatten(starred, 0, [], ...args),
		...flatten(recent, 0, [], ...args),
	],
);
